import { getCategoryMenuNotPaginated, getMetadataCompany } from 'api/company';
import setCSSVariables from 'utils/setTheme';
import { themeBase } from 'constants';

export async function loadCompanyMetadata(loadMetaCompany, theme) {
  try {
    const { data, status } = await getMetadataCompany();
    if (status === 200) {
      const matters = await getCategoryMenuNotPaginated({
        fields: 'id,name,description,genre_ibic,padre_id',
      });
      if (matters.status === 200) {
        loadMetaCompany({
          ...data,
          matters: matters.data,
        });
      } else {
        loadMetaCompany(data);
      }
      if (data?.is_single_company) {
        if (theme !== data.theme) {
          setCSSVariables(data.theme);
        }
      } else {
        document.documentElement.style.setProperty('--primary-color', '#0069d9');
        document.documentElement.style.setProperty('--secondary-color', '#f2a20d');
        document.documentElement.style.setProperty('--color-terciario', '#0069d9');
      }
      return { success: true };
    }
    setCSSVariables(themeBase);
    return { success: false };
  } catch (e) {
    setCSSVariables(themeBase);
    return { success: false };
  }
}
